import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../../Components/Layout/Header.jsx'
import { ObavijestiPoker } from '../../../Components/Layout/ObavijestiPoker.jsx'



export class PokerFestival extends React.Component {


    constructor(props) {
        super(props);
        this.state = { tabs: ['Informacije', 'Raspored', 'Rezultati'], selectedTab: null }

        this.gotoTab = this.gotoTab.bind(this);
        casino.utils.createPageGoogleTagManagerEvent('Poker uživo', 'Poker festival', 'poker');
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
        this.gotoTab('Rezultati');
    }
    gotoTab(tab) {
        this.setState({ selectedTab: tab });
    }
    render() {
        return <div>
            <Switch>
                <Route render={(route) => <div>
                    <Header key="header" {...this.state} {...this.props} detailsHeader="true" headerText='Poker festival' headerBackUrl={'/poker/live'}></Header>
                </div>
                } />
            </Switch>

            <div className="white-background">
                <div className="poker-festival-background">
                    <div className='poker-festival-logo'></div>
                </div>

                <div className="poker-container-wider ">
                    <div className="margin-top-small padding-sides-medium-2">
                        <h3 style={{ marginTop: "-10px" }} >SuperSport Poker Festival...</h3>
                            ...je turnir koji se održao uživo u partnerstvu sa domaćinom Diamond Palace Casinom.
                        <br />
                    </div>
                    <div className="segment v2 margin-top-small padding-sides-medium-2">
                        {this.state.tabs && this.state.tabs.map((tab) =>
                            <button key={tab} onClick={() => this.gotoTab(tab)} className={'segment--btn' + (this.state.selectedTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                        )}
                    </div>


                    {this.state.selectedTab == 'Informacije' &&
                        <div className="padding-sides-medium-2">
                            <div>
                                <h3 className="v1">1. Casino domaćin</h3>
                                    Smješten u centru grada, odmah uz hotel Sheraton, Diamond Palace casino u svom otmjenom okruženju pruža utočište domaćim i internacionalnim gostima u vječnoj potrazi za nesvakidašnjim uzbuđenjima i užicima. Diamond Palace svojim se uređenjem i bogatom, za ove prostore posve originalnom ponudom, svrstava uz bok najrazvikanijim igračnicama svijeta. Zato ovo novo glamurozno zagrebačko odredište s punim pravom ističe svoju ambiciju da postane neizbježan dio turističke ponude glavnog grada i Zagreb smjesti na samo središte mape najprestižnijih europskih gambling destinacija i iz navedenog se Vidi da je SuperSport odabrao najboljeg partnera za Vaš ugodan boravak i najbolju zabavu kroz igru.
                                <div className="margin-bottom-small" />
                                    Više detalja o partneru na: <a className='link blue' href="http://www.casino-diamondpalace.com/">http://www.casino-diamondpalace.com/</a>.

                                <h3 className="v1 margin-top">2. Kvalifikacije na ‘’SuperSport Poker Festival’’</h3>
                                    SuperSport i ovaj put organizira Online Poker ligu gdje će 20 najboljih igrača osvojiti ulaznice. <a href="poker/promotions/ssopl" className='link blue'>Više o SSOPL pročitajte ovdje</a>.
                                U Diamond Palace Casinu igraju se sateliti uživo za Supersport 50 000€ GTD.

                                <h3 className="v1 margin-top">3. Turnirska naknada i nagradni fond</h3>
                                    Buyin za Supersport 50 000€ GTD je 220€.<div className="margin-bottom-small" />
                                    Garantirani nagradni fond je 50 000€.<div className="margin-bottom-small" />
                                <i>Nagradni fond je ukupan iznos uplata na turniru, nakon što se iz uplata izdvoje naknade koje zadržava Casino. Uplata i registracija u Casinu organizirat će se unutar prostorija samog casina kao i izdavanje potrebne dokumentacije. Za svaku uplatu na turnir i cash stol primijenit će se aktualni porezi igara na sreću u casinima RH.</i>

                                <h3 className="v1 margin-top">4. Live Streaming</h3>
                                    Za vrijeme organizacije turnira održat će se prijenos uživo putem Interneta što uključuje snimanje i direktan prijenos, igranje sa RFID kartama, grafičkim prikazom karata igrača, njihovog stanja žetona i imena. Igrači koji budu odabrani za igru na ‘’featured’’ stolu bit će prikazani uz komentar uživo. Svi sudionici na turniru – kod registracije daju pravo da ih se snima.
                                SuperSport zadržava pravo na distribuciju i korištenje svih materijala snimljenih na ‘’featured’’ i finalnom stolu te svog ostalog sadržaja za vrijeme trajanja događaja.
                                Prijenos uživo će biti vidljiv na stranicama SuperSport.hr i drugim kanalima u organizaciji SuperSporta kao što su društvene mreže Youtube, Facebook, Twitch i Twitter.
                                Sudionici turnira će morati dati pisano dopuštenje da ih se snima i prikazuje na različitim medijima u organizaciji SuperSporta.

                                <h3 className="v1 margin-top">5. Ograničenje za medije i sponzore igrača</h3>
                                    Igračima je omogućeno da reklamiraju na svojoj odjeći do dva logotipa od kojih samo jedan može biti iz industrije igara na sreću. Kako bi to pravo igrači mogli ostvariti, prije početka turnira moraju poslati zahtjev za odobrenjem istih. Igrači ne smiju reklamirati firme koje se bave distribucijom alkoholnih i duhanskih proizvoda, pornografije i slično. Logotip ne smije biti veći od 15 kvadratnih centimetara i smije se staviti na prsa ili na rukav. Zabranjeno je nositi logo na bilo kojem drugom dijelu obuće i odjeće, uključujući kape, kapuljače i šešire. Maksimalno dva igrača na finalnom stolu mogu imati logotipe istih firmi, osim logotipa SuperSport-a čiji logotip može nositi i više od dva igrača. Ako postoje više od dva igrača, koji bi željeli nositi logotipe istih firmi, morat će se samostalno dogovoriti koja dva od njih će ih nositi. Ukoliko se igrači ne mogu samostalno dogovoriti oko toga, odredit će se slučajnim odabirom. SuperSport i casino domaćin u bilo kojem trenutku zadržavaju pravo da zabrane nošenje određenog logotipa bez dodatnog obrazloženja.
                                Za svako fotograranje i snimanje izvan prostora organizacije SuperSport turnira zahtijeva se dopuštenje od strane Casina domaćina. Kada se fotografira i snima izvan prostora organizacije SuperSport turnira, osoblje casina domaćina mora ispratiti fotografa ili snimatelja i odlučiti što se smije snimati i fotografirati, a što ne smije. Casino će odrediti područja na koja je zabranjen ulaz za fotografe i snimatelje (obično je to trezor, uredi osiguranja i ostalog osoblja).
                                <br /><br />
                                    * Pogledajte atmosferu i rezultate sa <a className='link blue' href="https://casino.supersport.hr/poker/proljece2017?fd=">SuperSport Poker Festivala Proljeće 2017</a>.
                                <br /><br />
                            </div>
                        </div>
                    }


                    {this.state.selectedTab == 'Raspored' &&
                        <div className="margin-top">
                            <h3 className="v1 padding-sides-medium-2">Supersport 50 000€ GTD (200+20€)</h3>
                            <h3 className="v2 padding-sides-medium-2">16. listopad 2017 - 22. listopad 2017</h3>

                            <table className="margin-top table-1 v2 v3">
                                <tbody>
                                    <tr className="horizontal-lines">
                                        <td colSpan="3" className="text-left text text-6">16.10.2017</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className='text text-1 text-bold'>Satelit za SuperSport <span className='nowrap'>50 000€</span> GTD, 19:00h</td>
                                        <td className='text text-1'>20+2€ / 10k / 20 min</td>
                                        <td className='text text-1'>registracija do 6 level-a</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td colSpan="3" className="text-left text text-6">17.10.2017</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className='text text-1 text-bold'>Freeroll Satelit za SuperSport <span className='nowrap'>50 000€</span> GTD, 19:00h</td>
                                        <td className='text text-1'>0€ / 5€/10€/5k/5k/10k / 20 min</td>
                                        <td className='text text-1'>registracija do 6 level-a</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="3" className="text-left text text-6">18.10.2017</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className='text text-1 text-bold'>WARM UP, 19:00h</td>
                                        <td className='text text-1'>40+4€ / 20 k / 25 min</td>
                                        <td className='text text-1'>registracija do 8 level-a</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td colSpan="3" className="text-left text text-6">19.10.2017</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className='text text-1 text-bold'>SuperSport <span className='nowrap'>50 000€</span> GTD dan 1a, 17:00h</td>
                                        <td className='text text-1'>200+20€ /50k / 30 min</td>
                                        <td className='text text-1'>registracija do 9 level-a</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className='text text-1 text-bold'>Satelit za SuperSport <span className='nowrap'>50 000€</span> GTD, 21:00h</td>
                                        <td className='text text-1'>20+2€ / 10 k / 20 min</td>
                                        <td className='text text-1'>registracija do 6 level-a</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td colSpan="3" className="text-left text text-6">20.10.2017</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className='text text-1 text-bold'>SuperSport <span className='nowrap'>50 000€</span> GTD dan 1b, 17:00h</td>
                                        <td className='text text-1'>200+20€ / 50k / 30 min</td>
                                        <td className='text text-1'>registracija do 9 level-a</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className='text text-1 text-bold'>Satelit za SuperSport <span className='nowrap'>50 000€</span> GTD, 21:00h</td>
                                        <td className='text text-1'>20+2€ / 10 k / 20 min </td>
                                        <td className='text text-1'>registracija do 6 level-a</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td colSpan="3" className="text-left text text-6">21.10.2017</td>
                                    </tr>
                                    <tr >
                                        <td className='text text-1 text-bold'>SuperSport <span className='nowrap'>50 000€</span> GTD dan 1c, 17:00h</td>
                                        <td className='text text-1'>200+20€ / 50k / 30 min</td>
                                        <td className='text text-1'>registracija do 9 level-a</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className='text text-1 text-bold'>SuperSport <span className='nowrap'>50 000€</span> GTD dan 1d turbo, 21:00h</td>
                                        <td className='text text-1'>200+20€ / 50k / 15 min</td>
                                        <td className='text text-1'>registracija do 9 level-a</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td colSpan="3" className="text-left text text-6">22.10.2017</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className='text text-1 text-bold'>Finale SuperSport <span className='nowrap'>50 000€</span> GTD, 15:00h</td>
                                        <td className='text text-1'>45 min</td>
                                        <td className='text text-1'></td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className='text text-1 text-bold'>Side event KO, 17:00h</td>
                                        <td className='text text-1'>30+10+3€ / 20k / 20 min</td>
                                        <td className='text text-1'>registracija do 8 level-a</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td className='text text-1 text-bold'>PLO, 19:00h</td>
                                        <td className='text text-1'>40+4€ / 20k / 20 min</td>
                                        <td className='text text-1'>registracija do 8 level-a</td>
                                    </tr>
                                </tbody>
                            </table>


                            <br />
                            <div className='padding-sides-medium-2'>
                                <i>* svi turniri su reentry osim freeroll koji je rebuy</i>
                            </div>
                            <br />

                        </div>
                    }



                    {this.state.selectedTab == 'Rezultati' &&
                        <div>
                            <div className="padding-sides-medium-2">

                                <br />
                                    Jesensko izdanje SuperSport Poker Festivala održano je u suradnji SuperSport-a i Diamond Palace Casina od 16.10.2017 do 22.10.2017.
                                <br /><br />
                                    U prekrasnom prostoru Casina okupilo se preko 200 SuperSportovih igrača koji su uživali u tjednu izvrsnog Pokera. Nagradni fond je iznosio <span className="no-wrap">52.380,00€</span> a pobjednik Jovan osvojio je <span className="no-wrap">13.280,00€</span>.
                                <img className="as-block margin-top margin-bottom" src="https://cdn.supersport.hr/Casino/Images/pokerFestival2017_Jesen_Pobjednici_web.jpg" />


                                <h3 className="v1">Poredak</h3>
                            </div>


                            <table className="table-1 v2 ">
                                <thead>
                                    <tr>
                                        <th className="text-left text text-6" >Plasman</th>
                                        <th className="text-left text text-6" >Ime i prezime</th>
                                        <th className="text-right text text-6"  >Osvojena nagrada</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="horizontal-lines">
                                        <td>1.</td>
                                        <td className=" text-bold">Jovan</td>
                                        <td className="text-right text text-7">13.280 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>2.</td>
                                        <td className=" text-bold">Branimir</td>
                                        <td className="text-right text text-7">9.130 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>3.</td>
                                        <td className=" text-bold">Šime</td>
                                        <td className="text-right text text-7">7.980 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>4.</td>
                                        <td className=" text-bold">Zdenko</td>
                                        <td className="text-right text text-7">4.120 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>5.</td>
                                        <td className=" text-bold">Nikola</td>
                                        <td className="text-right text text-7">3.280 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>6.</td>
                                        <td className=" text-bold">Dragan</td>
                                        <td className="text-right text text-7">2.560 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>7.</td>
                                        <td className=" text-bold">Vlaho</td>
                                        <td className="text-right text text-7">2.040 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>8.</td>
                                        <td className=" text-bold">Mladen</td>
                                        <td className="text-right text text-7">1.430 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>9.</td>
                                        <td className=" text-bold">Bern</td>
                                        <td className="text-right text text-7">1.130 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>10.</td>
                                        <td className=" text-bold">Zajko</td>
                                        <td className="text-right text text-7">770 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>11.</td>
                                        <td className=" text-bold">Danijel</td>
                                        <td className="text-right text text-7">770 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>12.</td>
                                        <td className=" text-bold">Marek</td>
                                        <td className="text-right text text-7">770 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>13.</td>
                                        <td className=" text-bold">Dubravko</td>
                                        <td className="text-right text text-7">770 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>14.</td>
                                        <td className=" text-bold">Anton</td>
                                        <td className="text-right text text-7">510 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>15.</td>
                                        <td className=" text-bold">Saša</td>
                                        <td className="text-right text text-7">510 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>16.</td>
                                        <td className=" text-bold">Mario</td>
                                        <td className="text-right text text-7">510 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>17.</td>
                                        <td className=" text-bold">Domagoj</td>
                                        <td className="text-right text text-7">510 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>18.</td>
                                        <td className=" text-bold">Luka</td>
                                        <td className="text-right text text-7">510 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>19.</td>
                                        <td className=" text-bold">Josip</td>
                                        <td className="text-right text text-7">360 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>20.</td>
                                        <td className=" text-bold">Tomislav</td>
                                        <td className="text-right text text-7">360 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>21.</td>
                                        <td className=" text-bold">Owens</td>
                                        <td className="text-right text text-7">360 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>22.</td>
                                        <td className=" text-bold">Branimir</td>
                                        <td className="text-right text text-7">360 €</td>
                                    </tr>
                                    <tr className="horizontal-lines">
                                        <td>23.</td>
                                        <td className=" text-bold">Saša</td>
                                        <td className="text-right text text-7">360 €</td>
                                    </tr>
                                </tbody>
                            </table>

                            <br /><br />
                        </div>



                    }

                </div>
                <ObavijestiPoker {...this.props}></ObavijestiPoker>
            </div>
        </div>

    }
};
